import { render, staticRenderFns } from "./student-loader.vue?vue&type=template&id=8c28af2a&scoped=true&"
import script from "./student-loader.vue?vue&type=script&lang=js&"
export * from "./student-loader.vue?vue&type=script&lang=js&"
import style0 from "./student-loader.vue?vue&type=style&index=0&id=8c28af2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c28af2a",
  null
  
)

export default component.exports